import OapMediaCover from './code/Scripts/components/OapMediaCover.vue';

export default {
  components: {
    OapMediaCover,
  },
};
